import React, { useState, useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import { GetChangeStatus, GetRoleList, DeleteRole, GetAllRoleList } from '../../../services/company_panel/platform_user/platformUserService';
import Swal from 'sweetalert2'
import { Button, Card, Table, Container, Row, Col, Modal } from 'react-bootstrap';
import { capitalizeFirstLetter, checkPermission, formateDate, getCompany, getOutletId } from '../../../helpers/commonFunctions';
import $ from "jquery"
import CustomPagination from '../../../components/company_panel/common/custompagination'
import notFound from '../../../assets/company/img/no-record-found.png'
import { usePersistedListState } from '../../../hooks/usePersistedListState';
import Loader from '../../../components/company_panel/common/loader'
import { GetTransferStockOutRequestsList } from '../../../services/company_panel/transferStockService';
import Sorting from '../../../components/company_panel/common/sorting';

const TransferOutList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    // persisted filters (page lives in the route) — restored on return from add
    const { saved, save, clear } = usePersistedListState('transfer_out');
    const [list, setList] = useState([]);
    const [statsUpdate, setStatusUpdate] = useState("false");
    const [dataLength, setDataLength] = useState();
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10);
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState(saved?.search || {});
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "");
    const [resetdate, setResetDate] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        });
    });

    useEffect(() => {
        if (search) {
            setTimeout(()=>{
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('from_outlet_id', getOutletId());
            GetTransferStockOutRequestsList(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                setLoader(false)
            }).catch(error => {
                console.log("error ====> ", error);
            })
        },1000)
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged, isOutletChanged])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        clear()
    }

    // Delete functionality
    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                DeleteRole(row).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'Record deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError",error);
                })
            }
        })
    }

    // edit functionality
    const editFunction = (row) => {
        navigate(`/company/platform-User/role/edit/${row}`)
    }
    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }


    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    return (
        <>
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Transfer stock</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                    {checkPermission('store_transfer_out', 'add') ?
                        <button className="btn btn-primary ms-2" onClick={() => navigate(`/company/store_manager/transfer_stock/transfer_out/${page}/add`)}>Create Transfer</button>
                    : '' }
                    </div>

                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <ul className="d-flex setting list-unstyled w-100 mb-0 p-0">
                            {checkPermission('store_transfer_in', 'view') ?
                                <li className="">
                                    <Link to={`/company/store_manager/transfer_stock/transfer_in/list/${1}`} className="btn btn-link" color='black'>Transfer In</Link>
                                </li>
                                : '' }
                            {checkPermission('store_transfer_out', 'view') ?
                                <li className="ms-3 active">
                                    <Link to={`/company/store_manager/transfer_stock/transfer_out/list/${1}`} className="btn btn-primary " color='black'>Transfer out</Link>
                                </li>
                                : ''}
                            </ul>
                        </div>
                    </div>
                    {/* <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} value={search.status === undefined ? '' : String(search.status)} />
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div> */}

                    <div className="table-responsive">
                        <table className="table table-custom">
                            <thead>
                                <tr>
                                    <th width="5%">
                                        <div className='d-inline-flex align-items-start'>
                                            <span>Id</span>
                                            <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="id" />
                                        </div>
                                    </th>
                                    {/* <th width="30%">Outlet</th> */}
                                    <th width="30%">
                                            <span>Outlet</span>
                                        </th>
                                    <th width="25%">
                                        <div className='sorting_column'>
                                            <span>Date</span>
                                            <Sorting sort={sorting} handleSort={handleSort} column="created_at" />
                                        </div>
                                    </th>
                                    <th width="25%">
                                        <div className='sorting_column'>
                                            <span>Status</span>
                                        </div>
                                    </th>
                                    {/* <th width="25%">
                                        <div className='sorting_column'>
                                            <span></span>
                                        </div>
                                    </th> */}
                                    {/* <th width="10%" className='action_head'></th> */}
                                    {checkPermission('store_transfer_out', 'view') ?
                                    <th width="15%" className='action_head'>Action</th>
                                    : ''}
                                </tr>
                            </thead>
                            <tbody>
                                {loader ? (
                                    <tr>
                                        <td colSpan={11}><Loader /></td>
                                    </tr>
                                ) : (
                                    <>
                                        {list.length ? list.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.id}</td>
                                                <td>{row.outlet?.outlet_name} {row.outlet?.short_code ? `(${row.outlet?.short_code})` : ""}</td>
                                                <td>{row.created_at ? formateDate(row.created_at) : "N/A"}</td>
                                                <td >{row.rejected == true ?
                                                    'Rejected' :
                                                    (row.recieved ?
                                                        'Recieved' :
                                                        (row.accepted ?
                                                            'Accepted' :
                                                            'Created'
                                                        )
                                                    )}
                                                </td>
                                                {checkPermission('store_transfer_out', 'view') ?
                                                <td>
                                                    <Button variant="primary" className="me-3" style={{ width: '200px' }} onClick={() => { setShowModal(true); setModalData(row) }}>View</Button>
                                                </td>
                                                : '' }
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No Record.</p>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className='tabler-footer'>
                        <div className='d-flex align-items-center'>
                            <div id="example1_info" role="status" className="table-result" aria-live="polite">
                                <b>Total Records : {dataLength || "0"}</b>
                            </div>
                            {dataLength && dataLength > 0 ? (
                                <CustomPagination
                                    datalength={dataLength}
                                    itemperpage={itemPerPage}
                                    setPage={setPage}
                                    currentPage={page}
                                    pageRoute={[{ name: "outlet-management", path: "/company/store_manager/transfer_stock/transfer_out/list" }]}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1.5em' }}>
                        {capitalizeFirstLetter(modalData?.outlet?.outlet_name)} 
                        {modalData?.outlet?.short_code ? `(${modalData?.outlet?.short_code})` : ""}
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body style={{ padding: '0' }}>
                    <table className="table table-custom ">
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Inventory Stock</th>
                                <th>Unit of measure</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                modalData?.transfer_stock_request_inventories.map((request, i) => {
                                    return <tr key={i}>
                                        <td>{request?.inventory.item_name}</td>
                                        <td>{request?.quantity}</td>
                                        <td>{request?.transfer_unit_uom}</td>
                                    </tr>
                                })
                            }

                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-outline-primary' onClick={() => setShowModal(false)}>
                        Close
                    </button>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TransferOutList